// export const BASE_URL_CURATORS = 'http://5.63.158.254:8001/api/v1/';
// export const MEDIA_URL = 'http://5.63.158.254:8001/';

export const BASE_URL = 'https://xn--80adbjhjdphkzazegjwj6aa3l.xn--p1ai/api/v1/';
export const MEDIA_BASE_URL = 'https://xn--80adbjhjdphkzazegjwj6aa3l.xn--p1ai/';

